module.exports = __webpack_public_path__ + "static/media/dark-menu-painel.66bccc8d.svg";